import api from '@/services/api'

export default {
  namespaced: true,
  state() {
    return {
      origin: null,
      destination: null,
      tripType: 'one-way', // options: one-way, round-trip
      locations: [
        { value: 'St-Hubert', label: 'St-Hubert' },
        { value: 'Bagotville', label: 'Bagotville' }
      ], // TODO :: Make this dynamic based on database slots
      departureDate: null,
      returnDate: null,
      passengersCount: 1,
      maxPassengers: 9,
      daysOfWeek: [],
      loading: false,
      error: null,
    }
  },
  mutations: {
    READ_SCHEDULES( state, payload ) {
      state.daysOfWeek = payload
    },
    SET_OPTIONS( state, payload ) {
      state.origin = payload.origin
      state.destination = payload.destination
      state.tripType = payload.tripType
      state.departureDate = payload.departureDate
      state.returnDate = payload.returnDate
      state.passengersCount = payload.passengersCount
    },

    SET_LOADING( state, status ) {
      state.loading = status
    },
    SET_ERROR( state, error ) {
      state.error = error
    },
  },
  actions: {
    async readSchedules( { commit } ) {
      commit( 'SET_LOADING', true )
      commit( 'SET_ERROR', null )

      try {
        const response = await api.readSchedules()
        commit( 'READ_SCHEDULES', response.data )
      } catch( error ) {
        commit( 'SET_ERROR', error )
      } finally {
        commit( 'SET_LOADING', false )
      }
    }
  }
}